<template>
  <div class="auth-panel">
    <template v-if="sent">
      <h1 class="card-title">Check your email</h1>
      <p class="card-hint" role="status">
        We sent a link to reset your password. Open it from this device to continue.
      </p>
    </template>
    <template v-else>
      <h1 class="card-title">Forgot password</h1>
      <p class="card-hint">Enter your email and we will send you a link to reset your password.</p>
      <ForgotPasswordForm @onSuccess="onSent" @onFailure="onFailure" />
    </template>

    <p class="card-links">
      <router-link class="card-link" :to="{ name: 'Login' }">Back to sign in</router-link>
    </p>
  </div>
</template>

<script>
import ForgotPasswordForm from '@/components/auth/ForgotPasswordForm';

export default {
  name: 'ForgotPassword',
  components: {
    ForgotPasswordForm,
  },
  inject: {
    authStage: { default: null },
  },
  data() {
    return {
      sent: false,
    };
  },
  methods: {
    onSent() {
      this.sent = true;
    },
    onFailure() {
      if (this.authStage) this.authStage.pulse('error');
    },
  },
};
</script>
